import React, { useEffect, useState, useRef } from "react";
import "../styles/homepageproperty.css";
import { useTranslation } from "react-i18next";

const BACKEND_URL = "https://ddmwrl2uut5q8.cloudfront.net";

function HomePageProperty() {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // *** NEW: Create a ref to reference the scrollable DOM element ***
  const scrollContainerRef = useRef(null);

  // Fetch properties - this logic remains the same
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/properties`)
      .then((res) => res.json())
      .then((data) => setProperties(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error("Error fetching properties:", err);
        setProperties([]);
      })
      .finally(() => setLoading(false));
  }, []);

  // *** REFACTORED: Button click handlers now manipulate the scroll position ***
  const handleScroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      // Calculate how much to scroll. We'll scroll by the width of one card + its gap.
      // This is more robust than scrolling by a fixed number of pixels.
      const card = container.querySelector('.property-card');
      if (card) {
        const cardWidth = card.offsetWidth;
        const gap = parseInt(window.getComputedStyle(container).gap, 10) || 30;
        const scrollAmount = cardWidth + gap;

        container.scrollBy({
          left: direction === 'next' ? scrollAmount : -scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  };
  
  // *** REMOVED: All old logic like currentIndex, nextSlide, prevSlide, getVisibleCount, and visibleProperties is gone. ***
  // The component is now much simpler.

  return (
    <section className="homepage-property">
      {/* The main wrapper no longer needs touch handlers, CSS handles it. */}
      <div className="property-cards-container-wrapper">
        <div className="container">
          <div className="property-intro">
            <h2>{t("homeProperty.intro.title")}</h2>
            <p>{t("homeProperty.intro.description1")}</p>
            <p className="highlight">{t("homeProperty.intro.highlight")}</p>
          </div>

          {loading ? (
            <p className="loading-text">{t("homeProperty.loading")}</p>
          ) : (
            // Using a React Fragment as the parent for the carousel and its controls
            <>
              <div className="simple-property-carousel">
                {/* *** Attach the ref to the scrollable container *** */}
                <div
                  className="property-cards-container"
                  ref={scrollContainerRef}
                >
                  {/* *** Render ALL properties, not just the "visible" ones *** */}
                  {properties.map((prop) => {
                    if (!prop) return null;

                    const displayTitle =
                      typeof prop.title === "object" && prop.title !== null
                        ? prop.title[currentLanguage] || prop.title.en || prop.title.sq || t("homeProperty.card.defaultTitle")
                        : prop.title || t("homeProperty.card.defaultTitle");

                    const displayPurpose =
                      typeof prop.purpose === "object" && prop.purpose !== null
                        ? prop.purpose[currentLanguage] || prop.purpose.en || prop.purpose.sq || t("homeProperty.card.defaultPurpose")
                        : prop.purpose || t("homeProperty.card.defaultPurpose");

                    const imageAltText = displayTitle !== t("homeProperty.card.defaultTitle")
                                          ? displayTitle
                                          : t("homeProperty.card.defaultImageAlt");

                    return (
                      <div key={prop.id} className="property-card">
                        <div className="property-image">
                          <img
                            src={
                              prop.image
                                ? `${BACKEND_URL}${prop.image}`
                                : "/images/placeholder-property.jpg"
                            }
                            alt={imageAltText}
                            title={imageAltText}
                          />
                          {prop.status && (
                            <span
                              className={`status-dot ${prop.status.toLowerCase().replace(/\s+/g, '_')}`}
                              title={t(`homeProperty.status.${prop.status.toLowerCase().replace(/\s+/g, '_')}`, prop.status)}
                            />
                          )}
                        </div>

                        <div className="property-info">
                          <h3 style={{ minHeight: "40px" }}>
                            {displayTitle}
                          </h3>
                          <p style={{ minHeight: "30px" }}>
                            <strong>{t("homeProperty.card.areaLabel")}</strong> {prop.area || t("homeProperty.card.notAvailable")}
                          </p>
                          <p style={{ minHeight: "60px" }}>
                            <strong>{t("homeProperty.card.purposeLabel")}</strong> {displayPurpose}
                          </p>
                          <a href={`/properties/${prop.id}`} className="view-button">
                            {t("homeProperty.card.viewButton")}
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              
              {/* Controls are now simplified and call the new handleScroll function */}
              <div className="carousel-controls">
                <button className="carousel-button prev" onClick={() => handleScroll('prev')} aria-label={t("homeProperty.carousel.prev")}></button>
                <button className="carousel-button next" onClick={() => handleScroll('next')} aria-label={t("homeProperty.carousel.next")}></button>
              </div>

              {/* *** REMOVED: Dots are no longer needed for a scroll-snap carousel *** */}
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default HomePageProperty;